import { EnviromentZone, IHowdenEnvironment, LogLevel } from '@howdeniberia/core-front';
import { howdenGroupMicrosoftEntraDevConfig } from './microsoft-entra-howden-group-dev';

export const environment = {
  zone: EnviromentZone.DEVELOPMENT,
  appIdSecurity: 0,
  logLevel: LogLevel.VERBOSE,
  openid: howdenGroupMicrosoftEntraDevConfig
} as IHowdenEnvironment;
